import api from './axiosConfig';

export const projectsAPI = {
  getAll: async (params = {}) => {
    const response = await api.get('/projects', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },
  
  create: async (formData) => {
    const response = await api.post('/projects', formData);
    return response.data;
  },
  
  update: async (id, formData) => {
    const response = await api.put(`/projects/${id}`, formData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/projects/${id}`);
    return response.data;
  },
};
